<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('common:tags') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:tag.tag') })"
            icon="edit"
            icon2="delete"
            @clickedButton2="deleteTag"
            @updateTableData="updateTable"
            @clickedButton1="editTag"
            @clickedAddButton="editTag"
            :addBtn="true"
            sortBy="name"
        />

      </v-col>
    </v-row>

    <TagForm
        @updateTable="updateTableAfterManipulation"
        :metas="metas"
        ref="tagForm" />

  </div>
</template>
<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import TagService from '@/modules/settings/services/tag-service';
import MetaService from '@/modules/settings/services/meta-service';
import Tag from '@/modules/core/data/tag';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import TagForm from "@/modules/settings/views/settings/tag/TagForm";

export default {
  name: "TagTable",
  components: {
    TagForm,
    DataTablePaginated
  },
  data() {
    return {
      metas: [],
      metasMap: new Map()
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('settings/settings:tag.meta-info'), value: 'metaName', sortable: false},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      TagService.readAllTagsPaginated(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Tag);

            response.data.content.forEach(
                (tag) => {
                  tag.metaName = this.metasMap.get(tag.metaInfo) ? this.metasMap.get(tag.metaInfo) : '~';
                }
            )

            this.$refs.table.fillTableData(response.data);
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:tag.tag')}));
          }
      )
    },
    updateTableAfterManipulation() {
      this.$refs.table.callTableUpdate();
    },
    editTag(tag) {
      this.$refs.tagForm.initialization(tag);
    },
    deleteTag(tag) {
      TagService.deleteTag(tag.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('settings/settings:tag.tag')}));
            this.updateTableAfterManipulation();
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('settings/settings:tag.tag')}));
          }
      );
    },
  },
  created() {
    MetaService.getAllMeta(
        (response) => {
          this.metas = response.data;
          this.metas.forEach(
              (meta) => {
                this.metasMap.set(meta.id, meta.name);
              }
          )
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:meta.meta')}));
        }
    )
  }
}
</script>
